var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManutencao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1380",
    "data-name": "Grupo 1380",
    transform: "translate(-256 -2851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1365",
    "data-name": "Grupo 1365",
    transform: "translate(256 2851)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_192",
    "data-name": "Ret\\xE2ngulo 192",
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1379",
    "data-name": "Grupo 1379",
    transform: "translate(-0.001 -40.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_4",
    "data-name": "Uni\\xE3o 4",
    d: "M10.49,12.964,2.456,21,0,18.543S4.154,14.38,8.025,10.5L5.942,8.415A4.319,4.319,0,0,1,0,4.372,4.27,4.27,0,0,1,.731,1.966L4.355,5.594,5.594,4.356,1.97.732A4.347,4.347,0,0,1,8.73,4.356a4.4,4.4,0,0,1-.312,1.586l2.072,2.082c.766-.768,1.472-1.477,2.073-2.082a4.3,4.3,0,0,1-.312-1.586A4.347,4.347,0,0,1,19.014.732L15.389,4.356l1.234,1.238,3.629-3.628a4.27,4.27,0,0,1,.731,2.405,4.323,4.323,0,0,1-5.946,4.043L12.956,10.5c3.872,3.882,8.027,8.046,8.027,8.046L18.527,21Z",
    transform: "translate(259.001 2894.716)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManutencao);
export default __webpack_public_path__ + "static/media/manutencao.a9cf29d9c04a15ea0e4adda87f19a61e.svg";
export { ForwardRef as ReactComponent };